import {
    OPEN_AI_RESPONSE_START,
    OPEN_AI_RESPONSE_SUCCESS,
    OPEN_AI_RESPONSE_ERROR,
    CLEAR_AI_RESPONSE
} from "../constants";


export default function aiContents(state = { aiResponseLoading: false }, action) {

    switch (action.type) {
        case OPEN_AI_RESPONSE_START:
            return {
                ...state,
                aiResponseLoading: true
            };

        case OPEN_AI_RESPONSE_SUCCESS:
            return {
                ...state,
                [action.payload.name]: action.payload.content,
                aiResponseLoading: false
            };

        case OPEN_AI_RESPONSE_ERROR:
            return {
                ...state,
                aiResponseLoading: false,
            };

        case CLEAR_AI_RESPONSE:
            return {
                aiResponseLoading: false,
            }

        default:
            return state;
    }
}
